"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple component for displaying a card
 * @param {Object} children React children prop for wrapped content
 */
const Card = ({
  className,
  children,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledCard, {
  className: `rui-card ${className}`.trim(),
  ...otherProps,
  children: children
});

Card.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  contrast: _propTypes.default.bool,
  error: _propTypes.default.bool,
  outline: _propTypes.default.bool,
  thin: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  shadow: _propTypes.default.bool
};
Card.defaultProps = {
  contrast: undefined,
  error: undefined,
  outline: undefined,
  thin: undefined,
  rounded: undefined,
  shadow: undefined
};
var _default = Card;
exports.default = _default;